"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSelectedDigestTimesDto = instanceOfSelectedDigestTimesDto;
exports.SelectedDigestTimesDtoFromJSON = SelectedDigestTimesDtoFromJSON;
exports.SelectedDigestTimesDtoFromJSONTyped = SelectedDigestTimesDtoFromJSONTyped;
exports.SelectedDigestTimesDtoToJSON = SelectedDigestTimesDtoToJSON;
exports.SelectedDigestTimesDtoToJSONTyped = SelectedDigestTimesDtoToJSONTyped;
/**
 * Check if a given object implements the SelectedDigestTimesDto interface.
 */
function instanceOfSelectedDigestTimesDto(value) {
    if (!('primaryId' in value) || value['primaryId'] === undefined)
        return false;
    if (!('eveningId' in value) || value['eveningId'] === undefined)
        return false;
    return true;
}
function SelectedDigestTimesDtoFromJSON(json) {
    return SelectedDigestTimesDtoFromJSONTyped(json, false);
}
function SelectedDigestTimesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'primaryId': json['primaryId'],
        'eveningId': json['eveningId'],
    };
}
function SelectedDigestTimesDtoToJSON(json) {
    return SelectedDigestTimesDtoToJSONTyped(json, false);
}
function SelectedDigestTimesDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'primaryId': value['primaryId'],
        'eveningId': value['eveningId'],
    };
}
